export default __webpack_public_path__ + "static/media/info.d102c7a5.svg";